import React from "react";
import "./NewCityOverview.css";

const NewCityOverview = ({ insight }) => {

  return (
    <section className="ultracity-main-section">

      <div className="moderntesti-blur-one"></div>

      <div className="moderntesti-blur-two"></div>
      {/* LEFT HERO CARD */}

      <div className="ultracity-hero-card">

        <div className="ultracity-glow-one"></div>
        <div className="ultracity-glow-two"></div>

        <div className="ultracity-badge">
          <i className="fa-solid fa-location-dot"></i>
          Smart City Insight
        </div>

        <h2 className="ultracity-main-title">
          {insight?.city?.name}
        </h2>

        <p className="ultracity-main-description">
          Discover premium residential zones, luxury apartments,
          commercial hubs and fast-growing investment areas with
          powerful city insights and location analytics.
        </p>

        <div className="ultracity-stats-wrapper">

          <div className="ultracity-stat-box">
            <h3>
              {insight?.localities?.length || 0}+
            </h3>
            <span>Localities</span>
          </div>

          <div className="ultracity-stat-box">
            <h3>
              {insight?.apartments?.length || 0}+
            </h3>
            <span>Apartments</span>
          </div>

          <div className="ultracity-stat-box">
            <h3>
              {insight?.commercials?.length || 0}+
            </h3>
            <span>Commercial</span>
          </div>

        </div>

        <a
          href={insight?.url}
          target="_blank"
          rel="noopener noreferrer"
          className="ultracity-map-button"
        >
          Explore Full City Map
          <i className="fa-solid fa-arrow-right"></i>
        </a>

      </div>

      {/* RIGHT GRID */}

      {/* <div className="ultracity-right-grid">

    

        <div className="ultracity-modern-card">

          <div className="ultracity-card-top">

            <div className="ultracity-icon locality-icon">
              <i className="fa-solid fa-location-dot"></i>
            </div>

            <div>
              <h3>Prime Localities</h3>
              <p>Best residential zones</p>
            </div>

          </div>

          <div className="ultracity-list-wrapper">

            {insight?.localities?.map((e, i) => (
              <div className="ultracity-list-item" key={i}>
                <span></span>
                {e?.name}
              </div>
            ))}

          </div>

        </div>

        

        <div className="ultracity-modern-card">

          <div className="ultracity-card-top">

            <div className="ultracity-icon apartment-icon">
              <i className="fa-solid fa-building"></i>
            </div>

            <div>
              <h3>Luxury Apartments</h3>
              <p>Modern premium living</p>
            </div>

          </div>

          <div className="ultracity-list-wrapper">

            {insight?.apartments?.map((e, i) => (
              <div className="ultracity-list-item" key={i}>
                <span></span>
                {e?.aptName}
              </div>
            ))}

          </div>

        </div>

        

        <div className="ultracity-modern-card">

          <div className="ultracity-card-top">

            <div className="ultracity-icon commercial-icon">
              <i className="fa-solid fa-city"></i>
            </div>

            <div>
              <h3>Commercial Hubs</h3>
              <p>Growing business centers</p>
            </div>

          </div>

          <div className="ultracity-list-wrapper">

            {insight?.commercials?.map((e, i) => (
              <div className="ultracity-list-item" key={i}>
                <span></span>
                {e}
              </div>
            ))}

          </div>

        </div>

      </div> */}

      <div className="ultraproperty-grid-wrapper">

  {[
    {
      title: "Builder Floor",
      desc: "Premium independent floors",
      icon: "fa-building",
      className: "ultraproperty-green",
    },
    {
      title: "Plot",
      desc: "Residential & investment plots",
      icon: "fa-vector-square",
      className: "ultraproperty-orange",
    },
    {
      title: "Residential",
      desc: "Modern family living homes",
      icon: "fa-house",
      className: "ultraproperty-blue",
    },
    {
      title: "Kothi",
      desc: "Luxury independent villas",
      icon: "fa-hotel",
      className: "ultraproperty-purple",
    },
    {
      title: "Farm House",
      desc: "Nature & peaceful lifestyle",
      icon: "fa-tree-city",
      className: "ultraproperty-red",
    },
    {
      title: "Commercial",
      desc: "Business & office spaces",
      icon: "fa-city",
      className: "ultraproperty-dark",
    },
  ].map((item, i) => (
    <div className="ultraproperty-card" key={i}>

      <div className="ultraproperty-card-header">

        <div className={`ultraproperty-card-icon ${item.className}`}>
          <i className={`fa-solid ${item.icon}`}></i>
        </div>

        <div>
          <h3>{item.title}</h3>
          <p>{item.desc}</p>
        </div>

      </div>

      <button className="ultraproperty-btn">
        Explore Now
      </button>

    </div>
  ))}

</div>

    </section>
  );
};

export default NewCityOverview;